import { BlogEntry } from './content.model';

export const BLOG_CONTENT: BlogEntry[] = [
  {
    slug: 'portfolio-3d-cube',
    titleKey: 'BLOG.POSTS.PORTFOLIO_3D_CUBE.TITLE',
    descriptionKey: 'BLOG.POSTS.PORTFOLIO_3D_CUBE.DESCRIPTION'
  },
  {
    slug: 'dark-light-mode-two-worlds-one-dom',
    titleKey: 'BLOG.POSTS.DARK_LIGHT_MODE.TITLE',
    descriptionKey: 'BLOG.POSTS.DARK_LIGHT_MODE.DESCRIPTION'
  },
  {
    slug: 'design-decisions-intuition-tech-iteration',
    titleKey: 'BLOG.POSTS.DESIGN_DECISIONS.TITLE',
    descriptionKey: 'BLOG.POSTS.DESIGN_DECISIONS.DESCRIPTION'
  },
  {
    slug: 'form-follows-intent',
    titleKey: 'BLOG.POSTS.FORM_FOLLOWS_INTENT.TITLE',
    descriptionKey: 'BLOG.POSTS.FORM_FOLLOWS_INTENT.DESCRIPTION'
  },
  {
    slug: 'deployment-without-overhead-coolify',
    titleKey: 'BLOG.POSTS.COOLIFY.TITLE',
    descriptionKey: 'BLOG.POSTS.COOLIFY.DESCRIPTION'
  },
  {
    slug: 'etl-in-finance',
    titleKey: 'BLOG.POSTS.ETL_FINANCE.TITLE',
    descriptionKey: 'BLOG.POSTS.ETL_FINANCE.DESCRIPTION'
  }
];
